import type { ComponentType } from 'react';

import {
  withAlignment,
  withRtlSupport,
} from '@skyscanner/backpack-web/bpk-component-icon';
import {
  lineHeightSm,
  lineHeightBase,
  lineHeightLg,
  iconSizeSm,
  iconSizeLg,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

export const alignIconTextSm = (icon: ComponentType) =>
  withAlignment(withRtlSupport(icon), lineHeightSm, iconSizeSm);

export const alignIconTextBase = (icon: ComponentType) =>
  withAlignment(withRtlSupport(icon), lineHeightBase, iconSizeSm);

export const alignIconTextLg = (icon: ComponentType) =>
  withAlignment(withRtlSupport(icon), lineHeightLg, iconSizeLg);

export const AlignedSpanIconLgTextBase = withAlignment(
  'span',
  iconSizeLg,
  lineHeightBase,
);
